export default "__VITE_PUBLIC_ASSET__82af5ead__"